import { Loader2 } from "lucide-react";

/**
 * Full-page loading component used for lazy-loaded routes and major transitions
 */
export const PageLoader = () => (
    <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
);
